import { QUES_TYPE } from "../../../../../util/const";
import { FilesUpload } from "../../filesUpload/FilesUpload";
import { SingleSelect } from "../SingleSelect";
import "./styles.css";

const SingleSelectChipsFileUpload = ({ getOptions }) => {
  return (
    <>
      {getOptions(
        undefined,
        undefined,
        undefined,
        undefined,
        "0px 2px 4px 3px rgba(255, 151, 60, 0.5)",
        ""
      )}
    </>
  );
};

export default SingleSelect(
  FilesUpload(SingleSelectChipsFileUpload),
  QUES_TYPE.SINGLE_SELECT_CHIPS_FILE_UPLOAD
);
